import { ActivatedRoute } from '@angular/router'
import { map, switchMap } from 'rxjs/operators'
import { Observable, of } from 'rxjs'

export const getRouteParam = (
    route: ActivatedRoute,
    param: string
): Observable<string | null> =>
    route.paramMap.pipe(
        map((paramMap) => paramMap.get(param)),
        switchMap((value) => {
            if (value) {
                return of(value)
            }
            if (route.parent) {
                return getRouteParam(route.parent, param)
            }
            return of(null)
        })
    )
